import { useQuery } from "@tanstack/react-query";
import * as queries from '@supabase/queries';
export function useUserData(){
    return useQuery({
        queryKey: ["userData"],
        queryFn: async () => {
            const user = await queries.getUserSession();
            if(user.error){
                throw user.error;
            }
            // console.log(user)
            const res = await queries.getUserData(user.data.session?.user.id || "");
            if(res.error){
                throw res.error;
            }
            if(res.data.length === 0){
                throw new Error("No user found");
            }
            return res.data[0];
        },
        // refetchInterval: 3000
    })
}